import { Tag, Tooltip, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import type { DeviceDirection } from './attendanceApi'

/**
 * Terminal yo'nalishi — qurilmalar ro'yxatida va hodisalar jurnalida.
 *
 * <h2>⚠️ `BOTH` KULRANG, LEKIN KO'RINADI</h2>
 * Uni umuman chizmaslik eng oson yo'l edi ("ma'lumot yo'q — bo'sh
 * katak"), lekin bu aynan noto'g'ri: `BOTH` — hisobot xulqiga TA'SIR
 * qiladigan holat. O'sha qurilmadan kelgan kunlarda kelish va ketish
 * o'lchanmaydi, TAXMIN qilinadi. Bo'sh katak esa "hammasi joyida"
 * bo'lib o'qilardi va operator nega hisobotda "TARTIB" yozuvi turganini
 * hech qayerdan bilmasdi.
 *
 * ⚠️ Ranglar: kirish va chiqish ATAYLAB bir-biriga qarama-qarshi
 * (yashil / to'q sariq), `BOTH` esa neytral. Ikkalasini bir rangda
 * chizish ro'yxatga bir qarashda "qaysi eshik qayerda" degan savolga
 * javob bermasdi.
 */
const COLOR: Record<DeviceDirection, string> = {
  IN: 'green',
  OUT: 'orange',
  BOTH: 'default',
}

export function DeviceDirectionTag({
  direction,
  /** Hodisalar jurnalida joy tor — faqat yorliq, izohsiz */
  compact = false,
}: {
  direction: DeviceDirection | null
  compact?: boolean
}) {
  const { t } = useTranslation()

  // ⚠️ `null` = server maydonni umuman bermadi (eski versiya). Bu
  // `BOTH` bilan BIR XIL EMAS: birinchisi "bilmaymiz", ikkinchisi
  // "o'lchanmaydi deb belgilangan". Tire ikkalasini ajratadi.
  if (direction === null) {
    return <Typography.Text type="secondary">{t('common.dash')}</Typography.Text>
  }

  const tag = <Tag color={COLOR[direction]}>{t(`attendance.directions.${direction}`)}</Tag>
  if (compact) {
    return tag
  }
  return <Tooltip title={t(`attendance.directionHints.${direction}`)}>{tag}</Tooltip>
}
